'use client';

import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { styled } from '@linaria/react';
import { AiKeywordAdTypeResponse } from '@fe-news/constants/news/type';
import ArticleTitle from './ArticleTitle';

const ContentWrapper = styled.div`
  position: relative;
  background-color: white;
  padding: 8px 12px;
  margin-top: 12px;
  border-radius: 6px;
  border: solid 1px #e2e8f1;
  overflow: hidden;
  height: 273px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) and (min-width: ${SCREEN_SIZE.MOBILE}px) {
    padding: 16px 24px;

    background-image: url('/assets/images/ai-keyword-bg-tablet.webp');
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    height: 259px;
  }

  @media screen and (max-width: ${SCREEN_SIZE.MOBILE}px) {
    padding: 16px 12px;
  }

  background-image: url('/assets/images/ai-keyword-bg.webp');
  background-size: cover;
  background-repeat: no-repeat;
`;

type AsideAiKeywordAdContentProps = {
  data: AiKeywordAdTypeResponse[];
};

const AsideAiKeywordAdContent = ({ data }: AsideAiKeywordAdContentProps) => {
  return (
    <ContentWrapper>
      {data.map(item => (
        <ArticleTitle key={item.id} title={item.title} url={item.url} />
      ))}
    </ContentWrapper>
  );
};

export default AsideAiKeywordAdContent;
